<!--
 * @Description: 本月参与项目
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render ref="tableRender" :config="config" height="55vh" />
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
export default {
  name: 'CurrentMonthProject',
  props: {
    // 接口数据
    userId: {
      type: Number,
      default: 0,
      required: true
    },
    // 任务详情条件
    fullName: {
      type: String,
      default: '',
      required: true
    },
    // 任务详情条件
    phone: {
      type: [Number, String],
      default: 0,
      required: true
    },
    // 当前记录的审核状态，2为禁用则不可添加项目操作
    status: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data() {
    return {
      config: null,
      propData: {
        query: {}
      }
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    config.childMenu[0].defaultQuery = {
      userId: this.userId,
      fullName: this.fullName,
      phone: this.phone,
      _status: this.status
    };
    let part = config;
    this.config = [part];
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
